import { PlaylistForListFragment } from 'graphql/generated/graphql';

import PlaylistPlaceholderImage from 'assets/images/playlistPlaceholder.webp';
import LikedImage from 'assets/images/playlists/liked.webp';
import ListenedImage from 'assets/images/playlists/listened.webp';

export const getPlaylistName = (
  playlist: PlaylistForListFragment,
  formatMessage,
) => {
  switch (playlist.id) {
    case 'liked-audios':
      return formatMessage({
        id: 'components.MyFemtasy.myAudiosHeader',
      });
    case 'recently-listened':
      return formatMessage({
        id: 'components.MyFemtasy.recentlyPlayedHeader',
      });
    default:
      return playlist.name;
  }
};

export const getPlaylistImage = (playlist: PlaylistForListFragment) => {
  switch (playlist.id) {
    case 'liked-audios':
      return LikedImage;
    case 'recently-listened':
      return ListenedImage;
    default:
      return playlist.image?.image || PlaylistPlaceholderImage;
  }
};

export const filterUserPlaylists = (playlists: PlaylistForListFragment[]) =>
  playlists.filter(
    (playlist) =>
      playlist.id !== 'liked-audios' && playlist.id !== 'recently-listened',
  );
